import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ProfileRow } from "../ProfileRow";
import { renderValue } from "../renderValueHelper";
import { useTranslation } from "@helpers/translate";
import changeIcon from "@assets/images/icons/change-icon.svg";
import saveIcon from "@assets/images/icons/save-icon.svg";
import cancelIcon from "@assets/images/icons/cancel-icon.svg";

import "./index.sass";

export const PhoneRow = ({
  phone,
  editingField,
  editingValues,
  setEditingValues,
  phoneInputRef,
  handleSaveField,
  setEditingField,
  savingField,
  fieldError,
  clearFieldError,
}) => {
  const { __ } = useTranslation();

  const normalizedPhone = phone
    ? String(phone).replace(/^\+/, "").trim()
    : "";

  const hasPhone = Boolean(normalizedPhone);

  const currentValue =
    typeof editingValues.phone === "string"
      ? editingValues.phone.replace(/^\+/, "")
      : "";


  const fullPhone = hasPhone ? `+${normalizedPhone}` : null;

  const cancelEditing = () => {
    setEditingField(null);
    clearFieldError("phone");

    setEditingValues((previousValues) => ({
      ...previousValues,
      phone: normalizedPhone,
      phoneCountry: null,
    }));
  };

  const handleSave = () => {
    if (hasPhone) {
      return;
    }

    handleSaveField("phone", currentValue.trim());
  };

  const handleStartEditing = () => {
    if (hasPhone) {
      return;
    }

    setEditingField("phone");

    setEditingValues((previousValues) => ({
      ...previousValues,
      phone: "",
      phoneCountry: null,
    }));
  };

  const value =
    editingField === "phone" && !hasPhone ? (
      <div className="profile-row__edit-input">
        <PhoneInput
          inputRef={phoneInputRef}
          value={currentValue}
          onChange={(nextValue, selectedCountry) => {
            clearFieldError("phone");
            setEditingValues((previousValues) => ({
              ...previousValues,
              phone: nextValue,
              phoneCountry: selectedCountry?.dialCode
                ? {
                  dialCode: selectedCountry.dialCode,
                  format: selectedCountry.format || "",
                }
                : null,
            }));
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleSave();
            }

            if (event.key === "Escape") {
              cancelEditing();
            }
          }}
          country="ua"
          countryCodeEditable={false}
          specialLabel={false}
          placeholder="+380 (___) ___-____"
          enableSearch
          searchPlaceholder={__("common.search")}
          inputClass="profile-row__editable-input"
          containerClass="profile-row__phone-input-container"
          buttonClass="profile-row__phone-flag-btn"
          dropdownClass="profile-row__phone-dropdown"
        />
      </div>
    ) : (
      renderValue(fullPhone)
    );

  let actions = null;

  if (!hasPhone) {
    actions =
      editingField === "phone" ? (
        <>
          <button
            type="button"
            onClick={handleSave}
            disabled={savingField === "phone"}
            className="profile-action__save profile-action__button"
          >
            <img src={saveIcon} alt="save" />
          </button>

          <button
            type="button"
            onClick={cancelEditing}
            disabled={savingField === "phone"}
            className="profile-action__cancel profile-action__button"
          >
            <img src={cancelIcon} alt="cancel" />
          </button>
        </>
      ) : (
        <button
          type="button"
          onClick={handleStartEditing}
          className="profile-action__button"
        >
          <img src={changeIcon} alt="change" />
        </button>
      );
  }

  return (
    <ProfileRow
      label={__("profile.phone_number")}
      value={value}
      actions={actions}
      error={fieldError}
    />
  );
};
